/**
 * @GENERATED from Figma node 3638:51956
 */

import * as React from "react";
export type IconProps = Omit<React.SVGProps<SVGSVGElement>, "color">;
const VideoBright = (props: IconProps, ref: React.Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    focusable={false}
    role="presentation"
    ref={ref}
    {...props}
  >
    <path fill="#7F776F" d="m3.357 23 17.286-11L3.357 1z" />
    <path fill="#7F776F" d="m3.357 23 17.286-11L3.357 1z" />
  </svg>
);
const ForwardRef = React.forwardRef(VideoBright);
export { ForwardRef as VideoBright };
